import {theme as baseTheme} from 'smooth-doc/src/theme'
import {css} from '@xstyled/styled-components'
import bgImage from '../../images/front-bg.png'

export const theme = {
    ...baseTheme,
    colors: {
        ...baseTheme.colors,
      primary: '#0072BC',
      'primary-100': '#80B9DD',
      'primary-200': '#66AAD5',
      'primary-300': '#3393C6',
      'primary-400': '#1A84C1',
      'primary-500': '#0072BC',
      'primary-600': '#0068AC',
      'primary-700': '#005E9B',
      'primary-800': '#00548A',
      'primary-900': '#004A79',
        modes: {
          ...baseTheme.colors.modes,
          dark: {
            ...baseTheme.colors.modes.dark,
            background: '#061935',
          },
        }
    },
    global: css`
      html {
        overflow-y: scroll;
        height: 100%;
        min-height: 100%;
        font-size: 62.5%;
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
      }

      body {
        transition: 300ms ease-in color, 300ms ease-in background-color;
        margin: 0;
        font-family: 'Noto Sans', sans-serif !important;
        font-style: normal;
        font-weight: 400;
        font-size: 1.6rem !important;
        background-color: background;
        color: on-background;
        line-height: 1;
        -webkit-font-smoothing: unset;
        -moz-osx-font-smoothing: grayscale;
      }

      div[class*="DocLayout__Container"] {
        line-height: 1.4;
      }

      #ocs-events ~ div > table td:first-child {
        width: 30%;
      }

      h1 {
        color: #070f26;
      }

      h2,
      h3,
      h4,
      h5,
      h6 {
        color: #0072BC;
      }

      aside h4 {
        color: #0072BC !important;
      }

      .xstyled-color-mode-dark {
        h1 {
          color: #0072BC;
        }

        h2,
        h3,
        h4,
        h5,
        h6 {
          color: white;
        }

        aside h4 {
          color: white !important;
        }
      }

      :focus {
        outline: none !important;
      }

      #main {
        margin-top: 142px;
      }

      /** CUSTOM CSS **/

      // Headers

      .bottom-header {
        background-color: #070f26;
        border-bottom: 1px solid #2e404D;
      }

      // Links

      #main article a {
        text-decoration: none;
        font-weight: 500;
      }

      // Hover with underline
      #main article a:hover {
        text-decoration: underline;
      }

      // TAGS
      .beta {
        background-color: #FFC400;
        border-radius: 3px;
        color: white;
        font-size: 10px;
        font-weight: bold;
        margin-left: 5px;
        padding: 2px;
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 2px;
      }

      .beta::after {
        content: 'BETA'
      }

      .new {
        background-color: #00CB5D;
        border-radius: 3px;
        color: white;
        font-size: 10px;
        font-weight: bold;
        margin-left: 5px;
        padding: 2px;
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 2px;
      }

      .new::after {
        content: 'NEW'
      }

      .deprecated:where(:not(.redoc-wrap *)) {
        background-color: #FF7A00;
        border-radius: 3px;
        color: white;
        font-size: 10px;
        font-weight: bold;
        margin-left: 5px;
        padding: 2px;
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 2px;
      }

      .deprecated:where(:not(.redoc-wrap *))::after {
        content: 'DEPRECATED'
      }

      .sync {
        background-color: #FFC400;
        border-radius: 3px;
        color: white;
        font-size: 10px;
        font-weight: bold;
        margin-left: 5px;
        padding: 2px;
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 2px;
      }

      .sync::after {
        content: 'SYNC'
      }

      .async {
        background-color: #FFC400;
        border-radius: 3px;
        color: white;
        font-size: 10px;
        font-weight: bold;
        margin-left: 5px;
        padding: 2px;
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 2px;
      }

      .async::after {
        content: 'ASYNC'
      }

      .soon {
        background-color: #949494;
        border-radius: 3px;
        color: white;
        font-size: 10px;
        font-weight: bold;
        margin-left: 5px;
        padding: 2px;
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 2px;
      }

      .soon::after {
        content: 'SOON'
      }

      .recipient {
        background-color: #0072BC;
        border-radius: 3px;
        color: white;
        font-size: 10px;
        font-weight: bold;
        margin-left: 5px;
        padding: 2px;
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 2px;
      }

      .recipient::after {
        content: 'RECIPIENT'
      }

      .donor {
        background-color: #0072BC;
        border-radius: 3px;
        color: white;
        font-size: 10px;
        font-weight: bold;
        margin-left: 5px;
        padding: 2px;
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 2px;
      }

      .donor::after {
        content: 'DONOR'
      }

      // CODE
      .prism-code {
        background-color: #2E404D !important;
      }

      .language-json .token.string {
        color: #4DA3FF !important;
      }

      .inline-code {
        overflow-wrap: break-word;
        background-color: #F5F7FA !important;
        color: #0072BC !important;
      }
      .xstyled-color-mode-dark .inline-code {
        background-color: #000000 !important;
        color: #0072BC !important;
      }
      .xstyled-color-mode-dark blockquote .inline-code {
        background-color: #FFF !important;
      }
      pre[class*='language-'] code {
        font-family: inherit;
      }

      pre[class*='language-']::before {
        background: #d9d7e0;
        border-radius: 0 0 4px 4px;
        color: #232129;
        font-weight: bold;
        font-size: 12px;
        font-family: inherit;
        letter-spacing: 0.075em;
        line-height: 1;
        padding: 0.25rem 0.5rem;
        position: absolute;
        left: 1rem;
        text-align: right;
        text-transform: uppercase;
        top: 0;
      }

      pre[class~='language-java']::before {
        content: 'java';
        background: #E42600;
        color: white;
      }

      pre[class~='language-js']::before,
      pre[class~='language-javascript']::before {
        content: 'js';
        background: #FFC400;
      }

      pre[class~='language-jsx']::before {
        content: 'jsx';
        background: #61dafb;
      }

      pre[class~='language-typescript']::before,
      pre[class~='language-ts']::before {
        content: 'ts';
        background: #19A3FC;
        color: #fff;
      }

      pre[class~='language-tsx']::before {
        content: 'tsx';
        background: #19A3FC;
        color: #fff;
      }

      pre[class~='language-graphql']::before {
        content: 'GraphQL';
        background: #e10098;
        color: #fff;
      }

      pre[class~='language-html']::before {
        content: 'html';
        background: #005B96;
        color: #fff;
      }

      pre[class~='language-css']::before {
        content: 'css';
        background: #FF7A00;
        color: #fff;
      }

      pre[class~='language-mdx']::before {
        content: 'mdx';
        background: #FF7A00;
        color: #fff;
      }

      pre[class~='language-shell']::before {
        content: 'shell';
      }

      pre[class~='language-sh']::before {
        content: 'sh';
      }

      pre[class~='language-bash']::before {
        content: 'bash';
      }

      pre[class~='language-curl']::before {
        content: 'curl';
      }

      pre[class~='language-yaml']::before,
      pre[class~='language-yml']::before {
        content: 'yaml';
        background: #ffa8df;
      }

      pre[class~='language-markdown']::before {
        content: 'md';
      }

      pre[class~='language-json']::before,
      pre[class~='language-json5']::before {
        content: 'json';
        background: linen;
      }

      pre[class~='language-diff']::before {
        content: 'diff';
        background: #e6ffed;
      }

      pre[class~='language-text']::before {
        content: 'text';
        background: #fff;
      }

      pre[class~='language-flow']::before {
        content: 'flow';
        background: #e8bd36;
      }

      .gatsby-highlight {
        font-family: Hack, SFMono-Regular, Menlo, Monaco, Consolas,
        'Liberation Mono', 'Courier New', monospace;
      font-variant: no-common-ligatures no-discretionary-ligatures
        no-historical-ligatures no-contextual;

        position: relative;
        z-index: 0;
        margin: 0 0 16px 0;
        overflow: auto;

        .token {
          font-style: normal !important;
        }
      }

      // TABLE
      table:where(:not(.redoc-wrap table)) {
        border-collapse: separate;
        border-spacing: 0 4px;
        margin-top: -4px;
        margin-bottom: 16px;
        width: 100%;

        td:first-of-type > img {
          min-width: 16px;
        }

        th,
        td {
          margin: 0;
          color: #949494;
          background-color: #F5F7FA;
          border: solid 1px #F5F7FA;
          padding: 12px;

          :first-of-type {
            border-left-style: solid;
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
          }

          :last-child {
            border-right-style: solid;
            border-bottom-right-radius: 5px;
            border-top-right-radius: 5px;
          }
        }

        tr {
          th {
            color: #2E404D;
            font-weight: bold;
          }
        }

        a {
          color: #005B96 !important;
        }
      }

      .xstyled-color-mode-dark article table:where(:not(.redoc-wrap table)) {

        th,
        td {
          color: #ffffff;
          background-color: #2E404D;
          border: solid 1px #2E404D;
        }

        tr {
          th {
            color: #ffffff;
          }
        }

        a {
          color: #0072BC !important;
        }
      }

      // QUOTE
      #main blockquote {
        background-color: #0072BC !important;
        color: #fff;
        border: none !important;
        margin-right: 0 !important;
        margin-left: 0 !important;

        a {
          color: white !important;
          text-decoration: underline;
        }
      }

      // API REFERENCES

      .api-reference-text-container {
        display: flex;
        flex-direction: column;
        align-self: center;
        flex-grow: 1;
      }

      li .api-reference-text-container h4.api-reference-title {
        margin-bottom: 5px;
        color: var(--xstyled-colors-on-background-light, #3f3f46);
      }

      li .api-reference-text-container p.api-reference-description {
        font-size: 15px;
        color: #6C6C80;
      }

      .xstyled-color-mode-dark li .api-reference-text-container p.api-reference-description {
        color: white;
      }

      .api-reference-image {
        margin-right: 20px;
        height: 80px;
        width: 80px;
        min-width: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-self: center;
      }

      .check-me {
        display: flex;
        flex-direction: column;
        align-self: center;
        flex-grow: 0;
        margin-left: 10px;
      }

      a.check-api {
        line-height: 13.5px;
        text-align: center;
        box-sizing: unset;
        font-weight: 400;
        padding: 10.5px 13.5px;
        border-radius: 40px;
        font-size: 13.5px;
        margin-right: -8px;
        display: inline-block;
        min-width: 94.5px;
        text-decoration: none;
        -moz-outline-style: none !important;
        -webkit-transition: all 0.5s ease;
        -moz-transition: all 0.5s ease;
        -o-transition: all 0.5s ease;
        -ms-transition: all 0.5s ease;
        transition: all 0.5s ease;

        border: 2px solid var(--api-reference-color);
        background-color: transparent;
        color: var(--api-reference-color);
      }

      .api-reference:hover a.check-api {
        background-color: var(--api-reference-color);
        color: #fff
      }

      .api-reference:hover .api-reference-title, .api-reference:hover .api-reference-description {
        color: #0072BC;
      }

      .xstyled-color-mode-dark .api-reference:hover .api-reference-title, .xstyled-color-mode-dark .api-reference:hover .api-reference-description {
        color: #0072BC;
      }

      .xstyled-color-mode-dark a.check-api {
        background-color: var(--api-reference-color);
        color: white;
      }

      .xstyled-color-mode-dark .api-reference:hover a.check-api {
        background-color: transparent;
        color: white;
        border-color: white;
      }

      // Anchor
      .anchor {
        float: left;
        padding-right: 4px;
        margin-left: -20px;
      }
      h1 .anchor svg,
      h2 .anchor svg,
      h3 .anchor svg,
      h4 .anchor svg,
      h5 .anchor svg,
      h6 .anchor svg {
        visibility: hidden;
      }
      h1:hover .anchor svg,
      h2:hover .anchor svg,
      h3:hover .anchor svg,
      h4:hover .anchor svg,
      h5:hover .anchor svg,
      h6:hover .anchor svg,
      h1 .anchor:focus svg,
      h2 .anchor:focus svg,
      h3 .anchor:focus svg,
      h4 .anchor:focus svg,
      h5 .anchor:focus svg,
      h6 .anchor:focus svg {
        visibility: visible;
      }

      // Diagram

      .statediagram {
        background-color: white;
      }

      .mermaid {
        background: white;
        border-radius: 5px;
      }

      .mermaid > svg {
        border-radius: 5px;
        margin-left: auto;
        margin-right: auto;
      }

      // Image
      picture > img {
        box-shadow: unset !important;
      }

      .gatsby-resp-image-wrapper {
        background: white;
        border-radius: 5px;
        max-width: unset !important;
        text-align: center;
      }
      .gatsby-resp-image-background-image {
        padding-bottom: unset !important;
        max-width: 600px;
        height: auto !important;
        margin: auto !important;
      }
      .gatsby-resp-image-wrapper > picture > img {
        max-width: 600px;
        height: auto !important;
        margin: auto !important;
        position: relative !important;
      }

      .big-img > .gatsby-resp-image-wrapper > picture > img {
        max-width: unset !important;
      }

      .big-img.light {
        display: block;
      }

      .big-img.dark {
        display: none;
      }

      .xstyled-color-mode-dark .big-img.dark {
        display: block;
      }

      .xstyled-color-mode-dark .big-img.light {
        display: none;
      }


      .img {
        width: 100%;
        background: white;
        border-radius: 5px;
        max-width: unset !important;
        text-align: center;
      }

      .small-img {
        max-height: 250px !important;
      }

      .extra-small-img {
        max-height: 200px !important;
      }

      .medium-img {
        max-height: 400px !important;
      }

      // Zoom

      .zoomable {
        max-height: 600px;
      }

      .xstyled-color-mode-dark.medium-zoom--opened > .medium-zoom-overlay {
        background: #2E404D !important;
      }

      .medium-zoom--opened > .medium-zoom-overlay,
      .medium-zoom--opened > .medium-zoom-image,
      img.medium-zoom-image--opened {
        z-index: 50;
      }

      // Pace

      .pace {
        -webkit-pointer-events: none;
        pointer-events: none;

        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
      }

      .pace-inactive {
        display: none;
      }

      .pace .pace-progress {
        background: #0072bc;
        position: fixed;
        z-index: 2000;
        top: 0;
        right: 100%;
        width: 100%;
        height: 2px;
      }

      // REDOC
      
    .redoc-wrap {
        margin: 0;
        padding: 0;
        background-color: #FFFFFF;
    }

    .redoc-wrap svg{
      display: unset;
    }

    .redoc-wrap img[alt="API Logo"] {
      padding: 10px;
    }

    .redoc-wrap h1 {
      color: #0072bc !important;
      font-size: 1.8em !important;
    }

    .redoc-wrap h2 {
      color: #0072bc !important;
      font-size: 1.6em !important;
    }

    .redoc-wrap h3 {
      font-size: 1.4em !important;
      padding: 0.2em 0px !important;
      margin: 2.5em 0px 1.1em !important;
      color: unset;
      font-weight: bold;
    }

    .redoc-wrap h3[id^=request] {
      padding: 0.2em 0px;
      margin: 2.5em 0px 1.1em;
      color: rgb(51, 51, 51);
      font-weight: normal;
    }

    .redoc-wrap .redoc-markdown h3 {
      font-weight: bold;
    }

    .redoc-wrap h4 {
      font-size: 1em !important;
      font-weight: bold;
      color: unset;
      margin-block-start: 1.33em;
      margin-block-end: 1.33em;
    }

    .redoc-wrap h5 {
      color: rgba(38, 50, 56, 0.5);
    }

    .redoc-wrap div[id^="operation"] {
      padding-top: 1em !important;
    }

    .redoc-wrap div[id^="operation"] ~ div[id^="operation"]{
      padding-top: 40px !important;
    }

    .redoc-wrap p {
      text-align: justify;
      margin-block-end: 14px;
      margin-block-start: 14px;
    }

    .redoc-wrap .api-content ul {
      display: block;
      list-style-type: disc;
      margin-block-start: 1em;
      margin-block-end: 1em;
      padding-inline-start: 40px;
      unicode-bidi: isolate;
    }

    .redoc-wrap label[type="group"] > span {
      color: #070F26;
      font-weight: bold;
    }

    .redoc-wrap label.active > span, .redoc-wrap label:hover > span {
      color: #0072bc;
    }

    .redoc-wrap .jExHJM, .fuYbND, .jxECLY, .eXxlBI, .sc-hKpBwk, .sc-hZgfyJ, .kCuQXr, .gcIKUn {
      color: #0072bc !important;
    }

    .redoc-wrap .gBoUGw {
      background-color: #0072bc !important;
      color: white !important;
    }
    
    .redoc-wrap .sc-hKpBwk {
      border-color: #0072bc !important;
    }

    .redoc-wrap .sc-hzhJZQ.jXRCRV {
      background-color: #0072bc !important;
      color: white !important;
    }
      
    .redoc-wrap .sc-hzhJZQ {
      border-color: #0072bc !important;
      color: #0072bc;
    }

    .redoc-wrap label > span.operation-type, .redoc-wrap label:hover > span.operation-type {
      color: #fff;
    }

    .redoc-wrap span[type="primary"], span[type="hook"].operation-type {
      background-color: #0072bc;
    }

    .redoc-wrap a[download], .redoc-wrap a[download]:visited {
      color: #fff !important;
      border-color: #070F26;
      background-color: #070F26;
      border-radius: 18px;
    }

    .redoc-wrap a[download]:hover {
      color: #070F26 !important;
      background-color: #FFF;
    }

    .redoc-wrap a, .redoc-wrap a:visited {
      color: #070F26 !important;
    }

    .redoc-wrap a:hover {
      color: #0072bc !important;
    }

    .redoc-wrap .hoverable > a, .hoverable > a:visited {
      color: #0072bc !important;
    }

    .redoc-wrap .hoverable > a:hover {
      color: white !important;
    }

    .redoc-wrap .security-details li {
      margin-bottom: 14px !important;
    }
    
    .redoc-wrap .security-details p {
      margin-top: 0 !important;
      display: contents !important;
    }

    .redoc-wrap .security-details li:last-child > span > p{
      margin-bottom: 0 !important;
    }

    .redoc-wrap .beta {
      line-height: 14px;
      background-color: #FFC400;
      border-radius: 3px;
      color: white;
      font-size: 10px;
      font-weight: bold;
      margin-left: 5px;
      padding: 2px;
      display: inline-block;
      vertical-align: middle;
      margin-bottom: 2px;
    }

    .redoc-wrap .beta::after {
      content: 'BETA'
    }

    .redoc-wrap .new {
      line-height: 14px;
      background-color: #00CB5D;
      border-radius: 3px;
      color: white;
      font-size: 10px;
      font-weight: bold;
      margin-left: 5px;
      padding: 2px;
      display: inline-block;
      vertical-align: middle;
      margin-bottom: 2px;
    }

    .redoc-wrap .new::after {
      content: 'NEW'
    }

    .redoc-wrap .scrollbar-container label[role=menuitem] span:nth-child(2){
      overflow-wrap: break-word;
    }

    .redoc-wrap span[type="warning"] {
      background-color: #FF7A00;
    }
      
    // MISC
      
    .download {
      color: #070f26
    }

    .xstyled-color-mode-dark .download {
      color: #FFF
    }
    
    .text-white {
      color:#FFFFFF;
    }

    .text-center {
      text-align:center;
    }
    
    .w-100 {
      width:100%;
    }
    
    .numbered-list {
      counter-reset: listitem;
      list-style: none !important;
    }
    
    .numbered-list>li {
      position: relative;
      padding-left: 30px;
    }
    
    .numbered-list>li:after {
      color: white;
      counter-increment: listitem;
      content: counter(listitem);
      background: #070F26;
      font-size: 12px;
      font-weight: 500;
      line-height: 10px;
      text-align: center;
      padding: 5px 0;
      height: 20px;
      width: 20px;
      border-radius: 10px;
      position: absolute;
      left: 0;
      top: 3px;
    }
    
    .menu-tab {
      height: inherit;
      align-items: center;
      justify-content: center;
      padding: 0 4rem;
      text-transform: uppercase;
      text-align: center;
      line-height: 1.82rem;
      text-decoration:none;
    }
    
    .menu-tab:visited {
      color: inherit;
    }
    
    .menu-tab:hover {
      background-color:#0072BC;
      color:#FFFFFF;
    }
    
    // Dark mode
    .mode-button {
      width: 6.8rem;
      cursor: pointer;
      transition: all 0.5s ease;
      position: relative;
    }
    
    .mode-button img {
      display: block;
      width: 2rem;
      height: 2rem;
      margin: auto;
    }
    
    #icon-light {
      display: block;
    }
    
    #icon-dark {
      display: none;
    }
    
    #icon-mobile {
      display: none;
    }
    
    .mode-button:hover #icon-light {
      display: none;
    }
    
    .mode-button:hover #icon-dark {
      display: block;
    }
    
    .mode-button:hover {
      background: #FFFFFF;
    }
    
    .grid {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: stretch;
      align-content: stretch;
      padding: 0;
    }
    
    // Logo
    .logo-container {
      flex-grow: 0;
      display:block;
      position: relative;
      height: 96px;
      width: 30rem;
      margin-left: 6rem;
      box-sizing: content-box;
    }
    
    .logo-container > * {
      display: block;
      position: absolute;
      top: 0; right: 0; bottom: 0; left: 0;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
    }
  
    .logo-container a {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;    
    }
    
    // Algolia
    .doc-search {
      position: absolute;
      right: 15px;
    }
    
    .doc-search input {
      border-radius: 24px;
      border-color: #070F26;
      width: 315px !important;
    }
    
    .xstyled-color-mode-dark .doc-search input {
      background-color: #f4f4f5;
    }
    
    .doc-search div>div:nth-child(3) {
      padding-right: 5px;
    }
    
    :root {
      --docsearch-primary-color: #0072BC;
      --docsearch-logo-color: #0072BC;
    }
    
    body.xstyled-color-mode-dark {
      --docsearch-primary-color: #0072BC;
      --docsearch-logo-color: #0072BC;
      --docsearch-modal-background: #404040;
      --docsearch-searchbox-background: #373737;
      --docsearch-hit-background: #373737;
      --docsearch-searchbox-focus-background: #373737;
      --docsearch-footer-background: #404040;
      --docsearch-logo-color: #fff;
      --docsearch-key-gradient: linear-gradient(-225deg,#d5dbe4,#f8f8f8);
      --docsearch-key-shadow: inset 0 -2px 0 0 #cdcde6,inset 0 0 1px 1px #fff,0 1px 2px 1px rgba(30,35,90,0.4);
    }
    
    kbd {
      color:white;
      --xstyled-colors-control-border: #0F0F26;
      --xstyled-colors-control-background: #0F0F26;
    }
    
    // Landing
    #content-container {
        height: calc(100vh - 110px);
        background-color: white;
    }
    
    // Front banner
    .front-banner {
      background: url(${bgImage}) bottom right;
      height: 57.5vh;
      background-size: cover;
      position: relative;
      overflow: hidden;
      display: flex;
    }

    .front-banner::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(to right, #070f26 0%, #070f26 20%, transparent 200%);
      pointer-events: none;
      }
    
    .look {
      margin-left: 6rem;
      align-self: center;
      margin-top:-25px;
      z-index: 1;
    }
    
    .look h1 {
      margin-bottom: 20px;
      font-size: 6rem;
      font-weight: 400;
      line-height: 7rem;
      color: #0072bc;
      font-family: "Noto Serif";
    }
    
    .look h4 {
      margin: 0;
      margin-bottom:34px;
      font-size: 4rem;
      line-height: 5.5rem;
      font-weight:300;
    }
    
    .ctas {
      display: flex;
      flex-direction: row;
      gap: 10px;
      text-align: left;
      line-height: 1;
    }
      
    .ctas a {
      text-align: center;
      box-sizing: unset;
      font-weight: 400;
      padding: 1.4rem 1.8rem;
      border-radius: 40px;
      font-size:1.8rem;
      display: inline-block;
      min-width: 12.6rem;
      text-decoration: none;
      -moz-outline-style: none !important;
      -webkit-transition: all 0.5s ease;
      -moz-transition: all 0.5s ease;
      -o-transition: all 0.5s ease;
      -ms-transition: all 0.5s ease;
      transition: all 0.5s ease;
    }
    
    .ctas a:hover {
      background:transparent;
    }
    
    .ctas a.primary {
      background-color:#0072BC;
      color: white;
      border:2px solid #0072BC;
    }
    
    .ctas a.primary:hover {
      background:transparent;
    }
    
    .ctas a.secondary {
      background-color:#0F0F26;
      color:#FFFFFF;
      border:1px solid #FFFFFF;
    }
    
    .ctas a.secondary:hover {
      background-color:#FFFFFF;
      color:#0F0F26;
    }
    
    // Quick navigation
    #quick-navigation {
      padding:0;
      width: 100%;
    }
    #quick-navigation > .container {
      max-width:100%;
    }
    #quick-navigation > .container ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
    #quick-navigation > .container ul li a {
      font-size:2rem;
      color:#373737;
      line-height:26px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column-reverse;
      text-decoration: none;
      -moz-outline-style: none !important;
      -webkit-transition: all 0.5s ease;
      -moz-transition: all 0.5s ease;
      -o-transition: all 0.5s ease;
      -ms-transition: all 0.5s ease;
      transition: all 0.5s ease;
    }
    .xstyled-color-mode-dark #quick-navigation > .container ul li a {
        color:#FFFFFF;
    }
    a.faq-list-question {
      font-size:2rem;
      color:#373737;
      line-height:26px;
      position: relative;
      top: 2px;
    }
    a.faq-list-question:hover {
      text-decoration:underline;
    }
    .arrow-list-faq img {
      width:8px;
      height:16px;
    }
    #quick-navigation > .container ul li a.current-item {
      color:#0072BC;
    }
    
    #quick-navigation > .container ul li a.current-item svg path {
      fill:#0072BC;
    }
    
    .xstyled-color-mode-dark #quick-navigation > .container ul li a.current-item {
      color:#0072BC;
    }
    
    .xstyled-color-mode-dark #quick-navigation > .container ul li a.current-item svg path {
      fill:#0072BC;
    }
    
    .xstyled-color-mode-dark #quick-navigation > .container ul li a svg path {
      fill:#FFFFFF;
    }
    
    #quick-navigation > .container ul li a:hover, #quick-navigation > .container ul li a:hover svg path, #quick-navigation > .container ul li a:hover p {
      color:#0072BC;
      fill:#0072BC;
      transition: all 0.5s ease;
    }
    
    .xstyled-color-mode-dark #quick-navigation > .container ul li a:hover, .xstyled-color-mode-dark #quick-navigation > .container ul li a:hover svg path, .xstyled-color-mode-dark #quick-navigation > .container ul li a:hover p {
      color:#0072BC;
      fill:#0072BC;
      transition: all 0.5s ease;
    }
    
    #quick-navigation > .container ul#menu-blocks-nav-cwp li a:hover, #quick-navigation > .container ul#menu-blocks-nav-cwp li a:hover svg path, #quick-navigation > .container ul#menu-blocks-nav-cwp-fr li a:hover, #quick-navigation > .container ul#menu-blocks-nav-cwp-fr li a:hover svg path {
      color:#0072BC;
      fill:#0072BC;
    }
    
    .xstyled-color-mode-dark #quick-navigation > .container ul#menu-blocks-nav-iot li a:hover, .xstyled-color-mode-dark #quick-navigation > .container ul#menu-blocks-nav-iot li a:hover svg path, .xstyled-color-mode-dark #quick-navigation > .container ul#menu-blocks-nav-iot-fr li a:hover, .xstyled-color-mode-dark #quick-navigation > .container ul#menu-blocks-nav-iot-fr li a:hover svg path {
      color:#0072BC;
      fill:#0072BC;
    }
    
    #quick-navigation > .container ul {
       justify-content: space-between;
       display: grid;
       grid-template-columns: repeat(6, 1fr);
    }
   
    #quick-navigation > .container ul li:nth-child(odd) a {
      background-color:#F5F7FA;
    }
    #quick-navigation > .container ul li:nth-child(even) a {
      background-color:#FFFFFF;
    }
    .xstyled-color-mode-dark #quick-navigation > .container ul li:nth-child(odd) a {
      background-color:#061935;
    }
    .xstyled-color-mode-dark #quick-navigation > .container ul li:nth-child(even) a {
      background-color:#062344;
    }
    #quick-navigation > .container ul li a span:first-child {
      order: 1;
      padding: 10px 0 0 0;
    }
    #quick-navigation > .container ul li a span:last-child {
      order: 2;
      padding:0;
    }
    
    #quick-navigation > .container ul li a {
      height:24.2rem;
      padding:0 15px;
    }
    
    #quick-navigation > .container ul li p {
      font-size: 1.8rem;
      line-height: 2.4rem;
      color:#808080;
      margin-top: 0.8rem;
    }
    
    .xstyled-color-mode-dark #quick-navigation > .container ul li p {
      color:#FFFFFF;
    }
    
    #quick-navigation .menu-blocks-nav-iot-fr-container li:last-child a, #quick-navigation .menu-blocks-nav-iot-container li:last-child a{
        background-color: #51b8c0 !important;
      color:#FFFFFF !important;
    }
    
    #quick-navigation .menu-blocks-nav-iot-fr-container li:last-child a:hover, #quick-navigation .menu-blocks-nav-iot-container li:last-child a:hover {
      color:#373737 !important;
    }

    .menu-image-title-after.menu-image-not-hovered img, .menu-image-hovered.menu-image-title-after .menu-image-hover-wrapper, .menu-image-title-before.menu-image-title {
        position: relative;
        top: -2px;
        padding-right: 0;
        display: inline-block;
        width: 3.4rem;
        text-align: center;
        margin-right: 5px;
    }
    
    .header-navigation .menu-image-hover-wrapper .menu-image {
        display: none !important;
    }
    
    .header-navigation .menu-image-hover-wrapper img.hovered-image {
        margin-left: 0 !important;
    }
    
    // Footer
    
    #footer {
      background-color: #070f26;
      font-size: 1.9rem;
      color: #99a1af;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-items: center;
      gap: 1rem;
      justify-self: center;
      justify-content: center;
      width: 100%;
      padding: 28px;
    }

    @media (min-width: 768px) {
      #footer {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 0;
      }

      #footer .copyright {
          justify-self: start;
        }

      #footer .links {
          justify-self: end;
        }
      }
    }

    #footer .company {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 0.25rem;
      justify-self: center;
      justify-content: center;
      
      img {
        display: inline-block;
        height: 15.4px;
        width: auto;
      }
    }

    #footer .links{
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      a {
        font-size: 1.9rem;
        color: #99a1af;
        font-weight: 500;
        text-decoration: none;
      }
      
      a:hover {
        text-decoration: underline;
      }
      
      .separator {
        margin-left: 8px;
        margin-right: 8px;
      }
    }
    
    // Fonts

    /* cyrillic-ext */
    @font-face {
      font-family: 'Noto Sans';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0ZIpQlx3QUlC5A4PNr4C5OaxRsfNNlKbCePevttHOmHS91ixg0.woff2) format('woff2');
      unicode-range: U+0460-052F, U+1C80-1C8A, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
    }
    /* cyrillic */
    @font-face {
      font-family: 'Noto Sans';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0ZIpQlx3QUlC5A4PNr4C5OaxRsfNNlKbCePevtvXOmHS91ixg0.woff2) format('woff2');
      unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
    }
    /* devanagari */
    @font-face {
      font-family: 'Noto Sans';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0ZIpQlx3QUlC5A4PNr4C5OaxRsfNNlKbCePevtuHOmHS91ixg0.woff2) format('woff2');
      unicode-range: U+0900-097F, U+1CD0-1CF9, U+200C-200D, U+20A8, U+20B9, U+20F0, U+25CC, U+A830-A839, U+A8E0-A8FF, U+11B00-11B09;
    }
    /* greek-ext */
    @font-face {
      font-family: 'Noto Sans';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0ZIpQlx3QUlC5A4PNr4C5OaxRsfNNlKbCePevttXOmHS91ixg0.woff2) format('woff2');
      unicode-range: U+1F00-1FFF;
    }
    /* greek */
    @font-face {
      font-family: 'Noto Sans';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0ZIpQlx3QUlC5A4PNr4C5OaxRsfNNlKbCePevtunOmHS91ixg0.woff2) format('woff2');
      unicode-range: U+0370-0377, U+037A-037F, U+0384-038A, U+038C, U+038E-03A1, U+03A3-03FF;
    }
    /* vietnamese */
    @font-face {
      font-family: 'Noto Sans';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0ZIpQlx3QUlC5A4PNr4C5OaxRsfNNlKbCePevttnOmHS91ixg0.woff2) format('woff2');
      unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
    }
    /* latin-ext */
    @font-face {
      font-family: 'Noto Sans';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0ZIpQlx3QUlC5A4PNr4C5OaxRsfNNlKbCePevtt3OmHS91ixg0.woff2) format('woff2');
      unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
    }
    /* latin */
    @font-face {
      font-family: 'Noto Sans';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0ZIpQlx3QUlC5A4PNr4C5OaxRsfNNlKbCePevtuXOmHS91iw.woff2) format('woff2');
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }
    /* cyrillic-ext */
    @font-face {
      font-family: 'Noto Sans';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0bIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjc5aPdu3mhPy1Fig.woff2) format('woff2');
      unicode-range: U+0460-052F, U+1C80-1C8A, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
    }
    /* cyrillic */
    @font-face {
      font-family: 'Noto Sans';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0bIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjc5ardu3mhPy1Fig.woff2) format('woff2');
      unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
    }
    /* devanagari */
    @font-face {
      font-family: 'Noto Sans';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0bIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjc5a_du3mhPy1Fig.woff2) format('woff2');
      unicode-range: U+0900-097F, U+1CD0-1CF9, U+200C-200D, U+20A8, U+20B9, U+20F0, U+25CC, U+A830-A839, U+A8E0-A8FF, U+11B00-11B09;
    }
    /* greek-ext */
    @font-face {
      font-family: 'Noto Sans';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0bIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjc5aLdu3mhPy1Fig.woff2) format('woff2');
      unicode-range: U+1F00-1FFF;
    }
    /* greek */
    @font-face {
      font-family: 'Noto Sans';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0bIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjc5a3du3mhPy1Fig.woff2) format('woff2');
      unicode-range: U+0370-0377, U+037A-037F, U+0384-038A, U+038C, U+038E-03A1, U+03A3-03FF;
    }
    /* vietnamese */
    @font-face {
      font-family: 'Noto Sans';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0bIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjc5aHdu3mhPy1Fig.woff2) format('woff2');
      unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
    }
    /* latin-ext */
    @font-face {
      font-family: 'Noto Sans';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0bIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjc5aDdu3mhPy1Fig.woff2) format('woff2');
      unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
    }
    /* latin */
    @font-face {
      font-family: 'Noto Sans';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      src: url(https://fonts.gstatic.com/s/notosans/v42/o-0bIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjc5a7du3mhPy0.woff2) format('woff2');
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }

    /* cyrillic-ext */
    @font-face {
      font-family: 'Noto Serif';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6faw1J5X9T9RW6j9bNfFIMZhhWnFTyNZIQD1-_P3Lct_NFiQhhYQ.woff2) format('woff2');
      unicode-range: U+0460-052F, U+1C80-1C8A, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
    }
    /* cyrillic */
    @font-face {
      font-family: 'Noto Serif';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6faw1J5X9T9RW6j9bNfFIMZhhWnFTyNZIQD1-_P3vct_NFiQhhYQ.woff2) format('woff2');
      unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
    }
    /* greek-ext */
    @font-face {
      font-family: 'Noto Serif';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6faw1J5X9T9RW6j9bNfFIMZhhWnFTyNZIQD1-_P3Pct_NFiQhhYQ.woff2) format('woff2');
      unicode-range: U+1F00-1FFF;
    }
    /* greek */
    @font-face {
      font-family: 'Noto Serif';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6faw1J5X9T9RW6j9bNfFIMZhhWnFTyNZIQD1-_P3zct_NFiQhhYQ.woff2) format('woff2');
      unicode-range: U+0370-0377, U+037A-037F, U+0384-038A, U+038C, U+038E-03A1, U+03A3-03FF;
    }
    /* math */
    @font-face {
      font-family: 'Noto Serif';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6faw1J5X9T9RW6j9bNfFIMZhhWnFTyNZIQD1-_PwPct_NFiQhhYQ.woff2) format('woff2');
      unicode-range: U+0302-0303, U+0305, U+0307-0308, U+0310, U+0312, U+0315, U+031A, U+0326-0327, U+032C, U+032F-0330, U+0332-0333, U+0338, U+033A, U+0346, U+034D, U+0391-03A1, U+03A3-03A9, U+03B1-03C9, U+03D1, U+03D5-03D6, U+03F0-03F1, U+03F4-03F5, U+2016-2017, U+2034-2038, U+203C, U+2040, U+2043, U+2047, U+2050, U+2057, U+205F, U+2070-2071, U+2074-208E, U+2090-209C, U+20D0-20DC, U+20E1, U+20E5-20EF, U+2100-2112, U+2114-2115, U+2117-2121, U+2123-214F, U+2190, U+2192, U+2194-21AE, U+21B0-21E5, U+21F1-21F2, U+21F4-2211, U+2213-2214, U+2216-22FF, U+2308-230B, U+2310, U+2319, U+231C-2321, U+2336-237A, U+237C, U+2395, U+239B-23B7, U+23D0, U+23DC-23E1, U+2474-2475, U+25AF, U+25B3, U+25B7, U+25BD, U+25C1, U+25CA, U+25CC, U+25FB, U+266D-266F, U+27C0-27FF, U+2900-2AFF, U+2B0E-2B11, U+2B30-2B4C, U+2BFE, U+3030, U+FF5B, U+FF5D, U+1D400-1D7FF, U+1EE00-1EEFF;
    }
    /* vietnamese */
    @font-face {
      font-family: 'Noto Serif';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6faw1J5X9T9RW6j9bNfFIMZhhWnFTyNZIQD1-_P3Dct_NFiQhhYQ.woff2) format('woff2');
      unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
    }
    /* latin-ext */
    @font-face {
      font-family: 'Noto Serif';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6faw1J5X9T9RW6j9bNfFIMZhhWnFTyNZIQD1-_P3Hct_NFiQhhYQ.woff2) format('woff2');
      unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
    }
    /* latin */
    @font-face {
      font-family: 'Noto Serif';
      font-style: italic;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6faw1J5X9T9RW6j9bNfFIMZhhWnFTyNZIQD1-_P3_ct_NFiQg.woff2) format('woff2');
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }
    /* cyrillic-ext */
    @font-face {
      font-family: 'Noto Serif';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6daw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTYf3D33WsNFHuQk.woff2) format('woff2');
      unicode-range: U+0460-052F, U+1C80-1C8A, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
    }
    /* cyrillic */
    @font-face {
      font-family: 'Noto Serif';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6daw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTYf-D33WsNFHuQk.woff2) format('woff2');
      unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
    }
    /* greek-ext */
    @font-face {
      font-family: 'Noto Serif';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6daw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTYf2D33WsNFHuQk.woff2) format('woff2');
      unicode-range: U+1F00-1FFF;
    }
    /* greek */
    @font-face {
      font-family: 'Noto Serif';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6daw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTYf5D33WsNFHuQk.woff2) format('woff2');
      unicode-range: U+0370-0377, U+037A-037F, U+0384-038A, U+038C, U+038E-03A1, U+03A3-03FF;
    }
    /* math */
    @font-face {
      font-family: 'Noto Serif';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6daw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTYeGD33WsNFHuQk.woff2) format('woff2');
      unicode-range: U+0302-0303, U+0305, U+0307-0308, U+0310, U+0312, U+0315, U+031A, U+0326-0327, U+032C, U+032F-0330, U+0332-0333, U+0338, U+033A, U+0346, U+034D, U+0391-03A1, U+03A3-03A9, U+03B1-03C9, U+03D1, U+03D5-03D6, U+03F0-03F1, U+03F4-03F5, U+2016-2017, U+2034-2038, U+203C, U+2040, U+2043, U+2047, U+2050, U+2057, U+205F, U+2070-2071, U+2074-208E, U+2090-209C, U+20D0-20DC, U+20E1, U+20E5-20EF, U+2100-2112, U+2114-2115, U+2117-2121, U+2123-214F, U+2190, U+2192, U+2194-21AE, U+21B0-21E5, U+21F1-21F2, U+21F4-2211, U+2213-2214, U+2216-22FF, U+2308-230B, U+2310, U+2319, U+231C-2321, U+2336-237A, U+237C, U+2395, U+239B-23B7, U+23D0, U+23DC-23E1, U+2474-2475, U+25AF, U+25B3, U+25B7, U+25BD, U+25C1, U+25CA, U+25CC, U+25FB, U+266D-266F, U+27C0-27FF, U+2900-2AFF, U+2B0E-2B11, U+2B30-2B4C, U+2BFE, U+3030, U+FF5B, U+FF5D, U+1D400-1D7FF, U+1EE00-1EEFF;
    }
    /* vietnamese */
    @font-face {
      font-family: 'Noto Serif';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6daw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTYf1D33WsNFHuQk.woff2) format('woff2');
      unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
    }
    /* latin-ext */
    @font-face {
      font-family: 'Noto Serif';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6daw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTYf0D33WsNFHuQk.woff2) format('woff2');
      unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
    }
    /* latin */
    @font-face {
      font-family: 'Noto Serif';
      font-style: normal;
      font-weight: 100 900;
      font-stretch: 100%;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/notoserif/v33/ga6daw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTYf6D33WsNFH.woff2) format('woff2');
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }
   
    // Responsive
    @media only screen and (max-width: 583px) {
      .top-header .grid {
        width: 100%;
      }
      .menu-tab {
        padding: 0 !important;
        flex-basis: 0;
        flex-grow: 1;
      }
      
      .logo-container {
        width: 25rem;
      }
      
      .look {
        margin-left: 0;
      }
      
      .ctas {
        flex-direction: column;
        place-items: flex-start;
      }
    }

    @media screen and (max-width:641px) {
      .look h1 {
        font-size: 5rem;
        line-height: 5.8rem;
      }
      .look h4 {
        font-size: 3rem;
        line-height: 4rem;
      }
      #quick-navigation > .container ul {
        justify-content: space-between;
        grid-template-columns: repeat(2, minmax(50%, 1fr));
      }
      #quick-navigation > .container ul li:nth-child(odd) a {
        background-color:initial;
      }
      #quick-navigation > .container ul li:nth-child(even) a {
        background-color:initial;
      }
      #quick-navigation > .container ul li:first-child a {
        background-color:#F5F7FA;
      }
      #quick-navigation > .container ul li:nth-child(2) a {
        background-color:#FFFFFF;
      }
      #quick-navigation > .container ul li:nth-child(3) a {
        background-color:#F5F7FA;
      }
      #quick-navigation > .container ul li:nth-child(4) a {
        background-color:#F5F7FA;
      }
    }
    
    @media only screen and (max-width: 1024px) {
        
        .container-404 .not-found {
          height: 50% !important;
          bottom: 50% !important;
          transform: translate(-50%, 50%) !important;
        }
        
        .container-404 .lost {
          margin-top: 0 !important;
        }

        .top-header {
          height: 45px;
          font-size: 75%;
          justify-content: flex-start;
        }
        
        .top-header .mode-button {
          display: none;
        }
        
        .top-header .grid {
          flex-flow: row;
        }

        .owl-carousel {
          position: relative;
        }

        .owl-carousel .owl-stage-outer {
          overflow: hidden;
          width: calc(100% - 15px);
        }
        
        .owl-item {
          height: 45px;
          a {
            padding-left: 20px !important;
            padding-right: 20px !important;  
          }
        }

        .owl-nav .owl-next, .owl-nav .owl-prev {
          position: absolute;
          top: 0;
          height: 45px;

          span {
            font-size: 45px;
            height: 45px;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 1;
            transform: translateY(-5px);
            font-weight: 200;
          }
        }
        
        .owl-nav .owl-next {
          right: 0;
        }

        .owl-nav .owl-prev {
          left: 0;
        }
        
        .owl-nav .owl-next.disabled, .owl-nav .owl-prev.disabled {
          display: none;
        }
        
        .bottom-header {
          height: unset;
        }
        
        .bottom-header .mode-button {
          height: 100%;
        }
        
        .bottom-header #icon-light {
          display: none;
        }
        
        .bottom-header #icon-dark {
          display: none;
        }
        
        .bottom-header #icon-mobile {
          display: block;
        }
        
        .mode-button:hover #icon-light {
          display: none;
        }
        
        .mode-button:hover #icon-mobile {
          display: none;
        }
        
        .mode-button:hover #icon-dark {
          display: block;
        }
        
        .menu-tab {
          padding: 0 2rem;
          line-height: 1.32rem;
          transition:all 0s ease !important;
        }
        
        .bottom-header .grid>div {
          justify-content: space-between;
        }
        
        .logo-container {
          margin-left: 0;
        }

        .logo-container > * {
          height: 86px;
          width: auto;
          margin: auto;
          background-size: contain;
        }
        
        .doc-search {
          display: none;
        }
        
        .front-banner {
          height:auto;
          padding: 7rem 20px 6rem 20px;
        }
        
        .menu-image-title-after.menu-image-not-hovered img, .menu-image-hovered.menu-image-title-after .menu-image-hover-wrapper, .menu-image-title-before.menu-image-title {
          width: 24px;
        }
        
        .menu-image-hover-wrapper img.hovered-image {
          opacity:1;
        }
    }
    
    @media screen and (min-width:642px) and (max-width:1067px) {
      #quick-navigation > .container ul {
        justify-content: space-between;
        grid-template-columns: repeat(3, minmax(33.33333%, 1fr));
      }
    }
    
    @media screen and (max-width:992px) {
      #quick-navigation .row, #quick-navigation .row > div  {
        padding:0;
        margin:0;
      }
    }
      
    @media screen and (min-width:1025px) and (-webkit-min-device-pixel-ratio: 1.2) {
      .menu-image-title-after.menu-image-not-hovered img, .menu-image-hovered.menu-image-title-after .menu-image-hover-wrapper, .menu-image-title-before.menu-image-title {
        width: 3rem;
      }
    }
    
    @media screen and (min-width:1025px) and (-webkit-min-device-pixel-ratio: 1.45) {
      html {
        font-size:46.875%;
      }
      
      .logo-container {
        position: relative;
        margin-left: 6rem;
        box-sizing: content-box;
      }
      
      .menu-tab {
        font-size: 1.4rem;
        line-height: 1.62rem;
      }
    }

    @media screen and (min-width:1068px) and (-webkit-min-device-pixel-ratio: 1.45) {
      #quick-navigation > .container ul li a {
        font-size: 1.8rem;
        line-height:2.4rem;
      }
      #quick-navigation > .container ul {
        justify-content: space-between;
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        justify-content: space-between;
      }
      #quick-navigation > .container ul li a {
        height:20rem;
        padding:0 15px;
      }
      #quick-navigation>.container ul li a span:last-child img+img {
        height: 6rem;
        position: relative;
        left: 0%;
        margin-left: 0rem!important;
      }
      #quick-navigation>.container ul li a span:last-child svg {
        height: 6rem;
        position: relative;
        left: 50%;
        transform: translatex(-50%);
      }
      #quick-navigation > .container ul li p {
        font-size: 1.6rem;
        line-height: 2.2rem;
        color: #808080;
        margin-top: 0.8rem;
      }
      #quick-navigation > .container ul li a span:first-child {
        order: 1;
        padding: 6px 0 0 0;
      }
      #quick-navigation > .container ul li a span:last-child img {
        height:6rem;
        position: relative;
        left: 50%;
        transform: translatex(-50%);
      }
      #quick-navigation > .container ul li a span:last-child img + img {
        height:6rem;
        position: relative;
        left:0%;
        margin-left:-0rem !important;
      }
    }
   
    @media screen and (min-width:1025px) and (-webkit-min-device-pixel-ratio: 1.25) and (-webkit-max-device-pixel-ratio: 1.40) {
      html {
        font-size : 53.125%;
      }
    }
    
    @media only screen and (min-width: 1025px) {
        
        .bottom-header .mode-button {
          display: none;
        }
        
        .bottom-header img {
          height: 100%;
        }

        .top-header .owl-carousel {
          width: unset;
        }
    }
    
    @media screen and (max-width:840px) {
      br.view-dekstop {
        display: none;
      }
      
      .container-404 .not-found {
        height: 40% !important;
      }

    }
    
    @media only screen and (max-width: 600px) {
      .container-404 .not-found {
        height: 30% !important;
      }
    }
    
    @media only screen and (max-width: 414px) {
      .container-404 .not-found {
        height: 20% !important;
      }
    }
    
    @media only screen and (max-width: 768px) {
      .check-me a {
        padding: 10.5px .5px;
      }
      .api-reference-image {
        height: 60px;
        width: 60px;
        min-width: 60px;
      }
    }
  `,
}
